import "../src/shared/stylesheets/ant/index.less";
import "../src/shared/plugins/adapters.js";
import "../src/shared/plugins/axiosSetup";
import "./easy_fireworks";
import "./easy_forms";
import "./utils";
import "./easy_ai";
import "./easy_journals";
import "./easy_ui";
import "./easy_ds_custom_elements";
import "./easyLocale";
import "./easySettings";
import "./easyPlugins";
import "./easy_help_feedback";
import "./automation";
import "./automations_webhook_button";
import "./sla";
import "./issue_detail_v2";
import "./query_language_editor";
import "./issue_detail_v2_feature_toggle";
import "./easy_legacy_js";
import "./easy_moment";
import "./projects";
import "./easy_contacts";
import "./entity_card_toggle";
import { initPage } from "@/src/utils/init";
import { openModalFromUrlHash } from "../src/utils/modals/modals";
import { registerStalePacksRecovery } from "@/src/utils/stalePacksRecovery";
import { initWebMcp } from "@/src/web_mcp/main";
import { openNotificationCenter, subscribeNotificationCenter } from "@/src/easy_notification_center";

// Must run before anything can trigger a lazy import.
registerStalePacksRecovery();

window.EASY ||= {};

window.EASY.notify = async data => {
  const { EasyNotifications } = await import("../src/easy_notifications");
  EasyNotifications.show(data);
};
// DYNAMIC FILTERS
window.EASY.appendReactiveQuery = async payload => {
  const { appendReactiveQuery } = await import("../src/dynamic_filters/main");
  appendReactiveQuery(payload);
};

// MIND MAPS
window.EASY.easyMindMap = async payload => {
  const { easyMindMap } = await import("../src/mind_maps/main");
  easyMindMap(payload);
};

// MAIN MENU
window.EASY.appendMainMenu = async payload => {
  const { appendMainMenu } = await import("../src/main_menu/main");
  appendMainMenu(payload);
};

// BREADCRUMB NAVIGATION
window.EASY.appendBreadcrumbNavigation = async payload => {
  const { appendBreadcrumbNavigation } = await import("../src/breadcrumb_navigation/main");
  appendBreadcrumbNavigation(payload);
};

// UI HELPERS
window.EASY.initUIHelpers = async payload => {
  const { initUIHelpers } = await import("../src/shared/utils/uiHelpers");
  initUIHelpers(payload);
};
EASY.schedule.main(() => {
  EASY.initUIHelpers();
});

// EASY PAGES SELECTOR
window.EASY.appendEasyPagesSelector = async payload => {
  const { appendEasyPagesSelector } = await import("../src/easy_page_selector/main");
  appendEasyPagesSelector(payload);
};

// MODALS
window.EasyVue ||= {};
window.EasyVue.modalData ||= {};
window.EasyVue.showModal = async (entityType, ID, options) => {
  const { showModal } = await import("../src/modals/main");
  showModal(entityType, ID, options);
};

window.EasyVue.showNewsOnboardingModal = async notificationKey => {
  if (!EASY.currentUser || !EASY.currentUser.logged) return;
  await window.EasyVue.showModal("news_onboarding", null, { notificationKey });
};

// easy schedule late because of CKeditor initialization
EASY.schedule.late(() => {
  openModalFromUrlHash();
});

window.EasyVue.loadCkeditor = async () => {
  const { loadCkeditor } = await import("../src/modals/main");
  loadCkeditor();
};

window.EasyVue.handleActivityFeedChanges = async issueId => {
  const { handleActivityFeedChanges } = await import("../src/modals/main");
  handleActivityFeedChanges(issueId);
};

window.EasyVue.createIssueTemplateForm = async (rootContainerId, templateData) => {
  const { createIssueTemplateForm } = await import("../src/issue_template_form/main");
  createIssueTemplateForm(rootContainerId, templateData);
};

window.EasyVue.createUseIssueTemplateModal = async projectId => {
  const { createUseIssueTemplateModal } = await import("../src/issue_template_form/main");
  createUseIssueTemplateModal(projectId);
};

window.EasyVue.createRichMenu = async payload => {
  const { createRichMenu } = await import("../src/rich_menu/main");
  createRichMenu(payload);
};

// WEBMCP — expose MCP tools to in-browser AI agents, deferred off the page-startup critical path.
EASY.schedule.late(() => initWebMcp());

window.EasyNotificationCenter = { open: openNotificationCenter };
subscribeNotificationCenter();

initPage();
